import React from 'react';
import ArtistPreview from './ArtistPreview';
import ReactList from 'react-list';

class ArtistList extends React.Component {

  renderItem(index, key) {
    return this.props.artists[index];
  }

  render() {
    if(!this.props.artists) return null;

    return (
      <div>
        <ReactList
          itemRenderer={this.renderItem.bind(this)}
          length={this.props.artists.length}
          type='uniform'
          useStaticSize={true}
        />
      </div>
    );
  }
}

export default ArtistList;



// WEBPACK FOOTER //
// ./src/components/ArtistList.js